<template>
  <main>
    <section class="admin-page">
      <div class="admin-toolbar">
        <div class="admin-selector">
          <v-icon small color="text_secondary" class="mr-2">mdi-shield-account</v-icon>
          <v-select
            v-model="cod_perfil"
            :items="perfis"
            item-text="dsc_perfil"
            item-value="cod_perfil"
            placeholder="Escolha um perfil"
            solo
            flat
            dense
            hide-details
            @change="onChange"
            background-color="surface_tertiary"
            class="admin-select"
          />
        </div>
        <div v-show="cod_perfil">
          <ModalInserirAprovador :fetchData="fetchData" :perfil="cod_perfil" />
        </div>
      </div>
      <div class="admin-table-wrapper">
        <DataTables
          v-if="aprovadores"
          :data="aprovadores.items[0]?.aprovador_perfil"
          :headers="headers"
          tab="aprovadores"
          :fetchData="fetchData"
        />
      </div>
    </section>
  </main>
</template>

<script>
import DataTables from "../components/DataTables.vue";
import ModalInserirAprovador from "@/components/Modal/Aprovador/ModalInserirAprovador.vue";
import { apiClient } from "../services/api";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "AprovadoresView",
  components: { DataTables, ModalInserirAprovador },
  data() {
    return {
      page: 1,
      size: 20,
      cod_perfil: null,
      isModalVisible: false,
      tableData: [],
      timer: null,
      tableItems: [],
      perfis: [],
      headers: [
        {
          text: "Aprovador",
          align: "start",
          sortable: false,
          name: "aprovador",
          class: " subtitle-1 font-weight-bold",
          value: "name",
        },
        {
          text: "Ação",
          sortable: false,
          class: "subtitle-1 font-weight-bold",
          value: "name",
          name: "action",
          align: "end",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      dark_theme: "themes/getTheme",
      aprovadores: "users/getterPerfis",
    }),
  },
  async created() {
    await this.getPerfis();
    await this.fetchData();
  },
  methods: {
    ...mapActions({
      getAprovadores: "users/getPerfis",
    }),
    async fetchData() {
      try {
        await this.getAprovadores({
          page: this.page,
          size: this.size,
          cod_perfil: this.cod_perfil,
        });
      } catch (error) {
        this.$toast.error("Erro ao buscar aprovadores.");
      }
    },
    async onChange(e) {
      this.cod_perfil = Number(e);
      await this.getAprovadores({
        page: this.page,
        size: this.size,
        cod_perfil: this.cod_perfil,
      });
    },
    async getPerfis() {
      const { data } = await apiClient.get(`/listaPerfisSocialCamFront`);
      this.perfis = data.perfis.items;
    },
  },
};
</script>

